import "./SuvaiHome.scss"
import dosa from "../../assets/images/dosa.png"
import dining from "../../assets/images/dining.png"
import springRolls from "../../assets/images/springrolls.png"
import paneer from "../../assets/images/paneer.png"
import noodles from "../../assets/images/noodles.png"
import tea from "../../assets/images/tea.png"
import vegan from "../../assets/images/vegan.png"
import drinks from "../../assets/images/drinks.png"
import chai from "../../assets/images/chai.png"
import dessert from "../../assets/images/dessert.jpg"
import rice from "../../assets/images/rice.png"
import wine from "../../assets/images/wine.jpg"
import store from "../../assets/images/store.png"
import reservation from "../../assets/reservation.svg"
import parking from "../../assets/parking.svg"
import privateDining from "../../assets/privateDining.svg"
import veg from "../../assets/veg.svg"
import Button from "../../components/button/Button"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import MenuItem from "../../components/MenuItem/MenuItem";
import { useHistory } from "react-router"
import ReviewSlider from "../../components/ReviewSlider/ReviewSlider"
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests"
const SuvaiHome = () => {
    const company = useSelector((state) => state.companyData.company);
    const { menuData, defualtSelectedLocation, organizationID, } = useSelector((state) => state.resturantData);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const [email, setEmail] = useState("")
    const [errors, setErrors] = useState({
        email: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )?.slice(0, 5)
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items.slice(0, 5) || [];
    }
    const componentOneData = [
        {
            "src": springRolls,
            "content": "Crafting Global Flavours with a Desi Twist",
            "header": "About Us"
        },
        {
            "src": noodles,
            "content": "Unique recipes that define our culinary style",
            "header": "Signature Plates"
        }, {
            "src": paneer,
            "content": "Events, News, and Culinary Inspirations",
            "header": "What’s Happening"
        },
    ]
    const componentThreeData = [
        {
            "src": tea,
            "content": "Tea rituals for health, focus & relaxation",
            "header": "Our Tea Selection"
        },
        {
            "src": vegan,
            "content": "Fresh Vegan Flavours",
            "header": "Vegan Delights"
        }, {
            "src": drinks,
            "content": "Explore the bar",
            "header": "Signature Drinks"
        },
    ]
    const componentFiveData = [
        { "src": "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGFuZWVyfGVufDB8fDB8fHww" },
        { "src": "https://plus.unsplash.com/premium_photo-1695297516676-04a259917c03?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8c2Ftb3NhfGVufDB8fDB8fHww" },
        { "src": "https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGp1aWNlc3xlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1701579231378-3726490a407b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGFuZWVyfGVufDB8fDB8fHww" },
        { "src": "https://images.unsplash.com/photo-1683533698664-12ee473e8c9d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2hhaXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1705359573325-f2006d5e459f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dGFuZG9vcml8ZW58MHx8MHx8fDA%3D" },
    ]
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;

        const newErrors = {
            email: ""
        };

        const trimmedEmail = email.trim();

        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.companyID || "",
            "Name": "",
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "Dosa N Chutney",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const getImages = (images) => {
        const result = [];
        for (let i = 0; i < images.length; i += 3) {
            result.push(images.slice(i, i + 3));
        }
        return result;
    };
    const componentSixData = [
        {
            "review": "Absolutely outstanding experience! From the moment we arrived, the service was warm, attentive, and genuinely friendly—they made us feel truly welcomed. The food was exceptional: beautifully presented, full of  flavour, and clearly made from high-quality ingredients.",
            "name": "THUVAA KURU"
        },
        {
            "review": "Absolutely outstanding experience! From the moment we arrived, the service was warm, attentive, and genuinely friendly—they made us feel truly welcomed. The food was exceptional: beautifully presented, full of  flavour, and clearly made from high-quality ingredients.",
            "name": "THUVAA KURU"
        }, {
            "review": "Absolutely outstanding experience! From the moment we arrived, the service was warm, attentive, and genuinely friendly—they made us feel truly welcomed. The food was exceptional: beautifully presented, full of  flavour, and clearly made from high-quality ingredients.",
            "name": "THUVAA KURU"
        }, {
            "review": "Absolutely outstanding experience! From the moment we arrived, the service was warm, attentive, and genuinely friendly—they made us feel truly welcomed. The food was exceptional: beautifully presented, full of  flavour, and clearly made from high-quality ingredients.",
            "name": "THUVAA KURU"
        },
    ]
    const componentNineData = [
        {
            "src": reservation,
            "header": "Reservations",
            "content": "Highly recommended"
        },
        {
            "src": parking,
            "header": "Parking",
            "content": "Street parking available"
        }, {
            "src": privateDining,
            "header": "Private Dining Room",
            "content": "Perfect for special occasions"
        }, {
            "src": veg,
            "header": "Vegetarian",
            "content": "Vegetarian options on request"
        },
    ]
    const componentSevenData1 = [
        {
            "src": dessert,
            "content": "Contact us",
            "header": "FULL-SERVICE CATERING"
        },
        {
            "src": store,
            "content": "Dine with us",
            "header": "AUTHENTIC DINING EXPERIENCE"
        },
    ]
    const componentSevenData2 = [
        {
            "src": chai,
            "content": "Rituals for Focus, Health & Slowness",
            "header": "Our Tea Selection"
        },
        {
            "src": wine,
            "content": "Book Now",
            "header": "PRIVATE DINING & EVENTS"
        }, {
            "src": rice,
            "content": " Suvai fusion To Go",
            "header": "TAKE AWAY"
        },
    ]
    return (
        <div className="SuvaiHome">
            <div className="SuvaiHome-hero">
                <div className="SuvaiHome-hero-textCont">
                    <div class="SuvaiHome-hero-textCont-vertical">WELCOME</div>
                    <div className="SuvaiHome-hero-textCont-right">
                        <div className="SuvaiHome-hero-textCont-right-header">THE  Suvai Fusion
                            EXPERIENCE</div>
                        <div className="SuvaiHome-hero-textCont-right-content">Suvai Fusion is dedicated to all those who love to wander far and wide
                        </div>
                        <div className="SuvaiHome-hero-textCont-right-btn">
                            <Button
                                text={"Order Now"}
                                type="SECONDARY" />
                        </div>
                    </div>
                </div>

                <div className="SuvaiHome-hero-imageCont"
                    style={{
                        backgroundImage: `url(${dosa})`
                    }} />
            </div>
            <div className="SuvaiHome-componentOne">
                {componentOneData?.map((data, key) => {
                    return (
                        <div key={key} className="SuvaiHome-componentOne-item"
                            style={{
                                backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                            }} >
                            <div className="SuvaiHome-componentOne-item-header">{data.header}
                            </div>
                            <div className="SuvaiHome-componentOne-item-content">{data.content}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="SuvaiHome-componentTwo">
                <div className="SuvaiHome-componentTwo-subheader"> Quality is at heart of everything we do</div>
                <div className="SuvaiHome-componentTwo-header">The Suvai Fusion Food Philosophy</div>
                <div className="SuvaiHome-componentTwo-line" />
                <div className="SuvaiHome-componentTwo-content">Our menu celebrates the rich blend of Sri Lankan and Indian flavours, inspired by the finest ingredients available. We are passionate about sourcing fresh produce, aromatic spices, and quality meats from trusted local markets and suppliers. By honouring traditional recipes while adding our own creative touch, we transform familiar classics into vibrant, flavourful dishes. Crafting authentic cuisine with warmth, freshness, and innovation is not just our mission — it’s our greatest joy</div>
            </div>
            <div className="SuvaiHome-componentThree">
                {componentThreeData?.map((data, key) => {
                    return (
                        <div key={key} className="SuvaiHome-componentThree-item"
                            style={{
                                backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                            }} >
                            <div className="SuvaiHome-componentThree-item-content">{data.content}
                            </div>
                            <div className="SuvaiHome-componentThree-item-header">{data.header}
                            </div>

                        </div>
                    )
                })}
            </div>
            <div className="SuvaiHome-componentFour">
                <div className="SuvaiHome-componentFour-header">Taste of Tradition</div>
                <div className="SuvaiHome-componentFour-line" />
                <div className="SuvaiHome-componentFour-grid">
                    {categories?.map((category) => {
                        return (
                            <MenuItem
                                items={
                                    getCatgoryItems(category.MenuEntities)
                                }
                                headerText={category?.Title?.en}
                            />)
                    })}</div>
                <div className="SuvaiHome-componentFour-btn">
                    <Button
                        text={"Full Menu"}
                        type="SECONDARY"
                        onClick={() => {
                            history.push("/menu")
                        }} />
                </div>

            </div>
            <div className="SuvaiHome-componentFive">
                {getImages(componentFiveData).map((img, key) =>
                (
                    <div className={`SuvaiHome-componentFive-left ${key % 2 === 0 ? "" : "reversed"}`} key={key}
                    >
                        <img alt="" src={img[0].src} className="SuvaiHome-componentFive-left-img" />
                        <div className="SuvaiHome-componentFive-left-img-list">
                            <img alt="" src={img[1].src} />
                            <img alt="" src={img[2].src} />
                        </div>
                    </div >
                )
                )}
            </div>
            <div className="SuvaiHome-componentSix">
                <ReviewSlider
                    reviews={componentSixData} />
            </div>
            <div className="SuvaiHome-componentSeven">
                <div className="SuvaiHome-componentSeven-header">
                    Explore Suvai Fusion
                </div>
                <div className="SuvaiHome-componentSeven-flex">
                    <div className="SuvaiHome-componentSeven-flex-grid2">
                        {componentSevenData1?.map((data, key) => {
                            return (
                                <div key={key} className="SuvaiHome-componentSeven-flex-grid2-item"
                                    style={{
                                        backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                                    }} >
                                    <div className="SuvaiHome-componentSeven-flex-grid2-item-content">{data.content}
                                    </div>
                                    <div className="SuvaiHome-componentSeven-flex-grid2-item-header">{data.header}
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                    <div className="SuvaiHome-componentSeven-flex-grid">

                        {componentSevenData2?.map((data, key) => {
                            return (
                                <div key={key} className="SuvaiHome-componentSeven-flex-grid-item"
                                    style={{
                                        backgroundImage: `linear-gradient(0deg, #090B09 0%, rgba(9, 11, 9, 0) 60%), url(${data?.src})`
                                    }} >
                                    <div className="SuvaiHome-componentSeven-flex-grid-item-content">{data.content}
                                    </div>
                                    <div className="SuvaiHome-componentSeven-flex-grid-item-header">{data.header}
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                </div>

            </div>
            <div className="SuvaiHome-componentEight">
                <div className="SuvaiHome-componentEight-inner">
                    <div className="SuvaiHome-componentEight-inner-header">
                        Stay connected with SUVAI FUSION
                    </div>
                    <div className="SuvaiHome-componentEight-inner-content">
                        Subscribe for the latest events, news, and culinary inspirations
                    </div>
                    <>
                        <div className="SuvaiHome-componentEight-inner-inputCont">
                            <div>
                                <input className={`SuvaiHome-componentEight-inner-inputCont-input ${errors.email !== "" ? "error" : ""}`}
                                    placeholder={"Enter your email"}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                        setErrors({
                                            ...errors,
                                            ["email"]: "",
                                        });

                                    }}
                                    value={email} />
                                {
                                    errors.email !== "" && < div className="input-error-text">
                                        {errors.email}
                                    </div>
                                }</div>
                            <Button
                                text={"Subscribe"}
                                onClick={handleContact}
                                loading={loading}
                                width={window.screen.width < 900 ? "calc(100vw - 32px)" : ""} />
                        </div>
                        {showSuccess && < div className="succes-alert">
                            Subscription successful! Thank you. </div>}</>
                </div>

            </div>
            <div className="SuvaiHome-componentNine-grid">
                {componentNineData.map((item, index) => {
                    return (
                        <div key={index} className="SuvaiHome-componentNine-grid-item">
                            <img alt="" src={item.src} className="SuvaiHome-componentNine-grid-item-img" />
                            <div className="SuvaiHome-componentNine-grid-item-header">{item.header}</div>
                            <div className="SuvaiHome-componentNine-grid-item-content">{item.content}</div>


                        </div>
                    )
                })}
            </div>
            <div className="SuvaiHome-componentTen">
                <div
                    className="SuvaiHome-componentTen-imageCont"
                    style={{
                        backgroundImage: `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${dining})`
                    }} >
                </div>
                <div className="SuvaiHome-componentTen-textContWarpper"
                    style={{
                        backgroundImage:
                            window.screen.width < 900 ? `linear-gradient(180deg, rgba(16, 18, 19, 0) 0%, rgba(16, 18, 19, 0.6) 40%, rgba(16, 18, 19, 0.6) 60%, rgba(16, 18, 19, 0) 100%), url(${dining})` : ""
                    }}>
                    <div class="SuvaiHome-componentTen-textContWarpper-vertical">see you</div>
                    <div className="SuvaiHome-componentTen-textContWarpper-textCont"
                    >
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-header">
                            Visit us
                        </div>
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-content">
                            Enjoy an exceptional culinary experience.
                        </div>
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-content">
                            Monday - Thusrday
                        </div>
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-content2">
                            12:00 PM - 10.00 PM
                        </div>
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-content">
                            Friday - Sunday
                        </div>
                        <div className="SuvaiHome-componentTen-textContWarpper-textCont-content2">
                            12.00 PM - 11.00 PM

                        </div>
                        <div
                            className="SuvaiHome-componentTen-textContWarpper-textCont-btn">
                            <Button
                                text={"book a table"}
                                type="SECONDARY"
                                onClick={() => {
                                    history.push("/menu")
                                }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="SuvaiHome-MobileFixed">
                <Button
                    text={"Order Now"}
                    padding={"14px 25px"}
                    width="100%"
                />
                <Button
                    text={"Book a table"}
                    type="SECONDARY"
                    padding={"14px 25px"}
                    width="100%"
                />
            </div>
        </div >
    )
}
export default SuvaiHome